import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Global scroll-reset: whenever the route's pathname changes (i.e. the user
 * navigates to a new page via a <Link>/navigate(), not a same-page hash
 * change), snap the window back to (0, 0) instead of keeping the previous
 * page's scroll position. Mounted once at the root (inside <BrowserRouter>,
 * see App.js) so it applies to every current and future route automatically
 * — no per-page wiring needed.
 */
export const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};
